import type { ReactNode } from "react";
import { Check } from "lucide-react";

import { cn } from "../../lib/utils";

export interface AIChatConfirmationMessageItemProps {
  className?: string;
  /** The line's text, rendered beside the checkmark. */
  children?: ReactNode;
}

/** One checkmarked line in an `AIChatConfirmationMessage`'s checklist. */
export const AIChatConfirmationMessageItem = ({ className, children }: AIChatConfirmationMessageItemProps) => (
  <div
    data-slot="ai-chat-confirmation-item"
    className={cn("flex items-start gap-2 rounded-xl bg-ai-muted px-3 py-2.5 text-foreground", className)}
  >
    <Check className="mt-0.5 h-4 w-4 shrink-0 text-ai" strokeWidth={2.4} />
    <span>{children}</span>
  </div>
);
